import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { API } from '../App';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import SessionCard from '../components/sessions/SessionCard';
import RequestJoinDialog from '../components/sessions/RequestJoinDialog';
import { apiError } from '../lib/apiError';

const SessionInvite = () => {
  const { bookingId } = useParams();
  const [session, setSession] = useState(null);
  const [error, setError] = useState('');
  const [target, setTarget] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/sessions/${bookingId}`);
      setSession(data);
    } catch (e) {
      setError(apiError(e, 'Session not found'));
    }
  }, [bookingId]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="session-invite-page">
      <Button asChild variant="ghost" className="mb-6"><Link to="/discover-sessions"><ArrowLeft className="w-4 h-4 mr-2" />Discover Sessions</Link></Button>
      <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-2">You're invited</h1>
      <p className="text-base md:text-lg text-slate-600 mb-8">A friend booked this group session. Ask to join — it's free for you once they accept.</p>
      {error ? (
        <p className="text-slate-500" data-testid="session-invite-error">{error}</p>
      ) : session ? (
        <SessionCard session={session} onRequest={setTarget} />
      ) : (
        <p className="text-slate-500">Loading...</p>
      )}
      <RequestJoinDialog session={target} onClose={() => setTarget(null)} onDone={() => { setTarget(null); load(); }} />
    </div>
  );
};

export default SessionInvite;
